import React, { useState } from "react";
import { Form, Input, Button, Spin } from "antd";
import { LoadingOutlined, MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import chart from "../../assets/images/dashboard.gif";
import logoPng from "../../assets/images/logopng.png";

import Theme from "../../theme/Theme";
import ForgotPasswordApi from "../../api/users/ForgotPasswordApi";
import { openNotificationSuccess } from "../../helpers/NotificationHelpers";

function ForgetPassword() {
  const [form] = Form.useForm();
  const [email, setEmail] = useState();
  const [submit, setSubmit] = useState(false);
  const [checkMail, setCheckMail] = useState(false);

  async function onFinish() {
    setSubmit(true);

    const apiResponse = await ForgotPasswordApi(email);
    if (apiResponse.error) {
      form.setFields([
        {
          name: "email",
          errors: [apiResponse.message],
        },
      ]);
    } else {
      form.resetFields();

      setCheckMail(true);
    }
    setSubmit(false);
  }
  async function resendMail() {
    setSubmit(true);

    const apiResponse = await ForgotPasswordApi(email);
    if (apiResponse.success) {
      openNotificationSuccess("bottomRight", `Mail resent successfully!`);
    }
    setSubmit(false);
  }

  return (
    <>
      <div
        className="flex w-full h-full items-center justify-center p-3"
        style={{ backgroundColor: "#f1f1f1" }}
      >
        <div className=" max-w-lg md:max-w-3xl md:p-3  md:grid  grid-cols-2 bg-white rounded-md">
          <div className="  p-8 flex flex-col justify-between">
            <div>
              <div className="pri-font text-2xl font-semibold mb-2 mt-4">
                {checkMail ? "Check your mail" : "Forgot password?"}
              </div>
              <div className="text-gray-600 mb-5">
                {checkMail ? (
                  <div>
                    Reset link sent to{" "}
                    <span className="font-semibold">{email}</span> Check Your
                    inbox
                  </div>
                ) : (
                  "Enter your email and we will send a link to your email to reset your password."
                )}
              </div>
            </div>
            {checkMail ? (
              <Button
                type="primary"
                htmlType={submit && "submit"}
                className="w-full"
                onClick={resendMail}
              >
                {submit ? (
                  <Spin
                    size="small"
                    indicator={
                      <LoadingOutlined style={{ color: "#fff" }} spin />
                    }
                  />
                ) : (
                  "Resend mail"
                )}
              </Button>
            ) : (
              <Form
                name="forgotPassword"
                className="w-full max-w-lg"
                initialValues={{ remember: true }}
                form={form}
                onFinish={onFinish}
                layout={"vertical"}
                requiredMark={false}
              >
                <Form.Item
                  label={<div className="text-gray-600">Email</div>}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter an email!",
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined style={{ color: Theme().primary }} />}
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType={submit && "submit"}
                    className="w-full"
                  >
                    {submit ? (
                      <Spin
                        size="small"
                        indicator={
                          <LoadingOutlined style={{ color: "#fff" }} spin />
                        }
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Form.Item>
              </Form>
            )}
            {checkMail ? (
              <div className="text-center mt-5 mb-4">
                Wrong mail?&nbsp;
                <span
                  className="text-blue-500 cursor-pointer"
                  onClick={() => setCheckMail(false)}
                >
                  Change
                </span>
              </div>
            ) : (
              <div className="text-center mt-5 mb-4">
                Remember password? &nbsp;
                <Link to="/login">Login</Link>
              </div>
            )}
          </div>
          <div className="bg-gray-100 p-8 rounded-md hidden md:block">
            <img className="w-48 " src={logoPng} alt="logo" />
            <div className="pri-font text-2xl font-semibold mt-16 mb-4">
              Let us help you manage business performance.
            </div>
            <div className="text-gray-600 mb-10">
              We'll help you monitor your corporate performance through data
              visualization.
            </div>
            <img
              className="h-44 mx-auto w-auto rounded-md overflow-hidden"
              src={chart}
              alt="chart"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetPassword;
